<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
import {formatDateTimeSecond} from '@qx/utils/index';

import {mapState} from 'vuex';
import {companyBankcardList, getOtherIncomeSysData} from 'api/getPay';
export default {
  data () {
    return {

      baseForm: {
        accountNameOptions: [],
        transactionPurposeOptions: [],
        form: [
          { // 交易时间
            label: '交易时间',
            value: 'transactionTime',
            type: 'date',
            placeholder: '请输入交易时间',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
          },
          {
            label: '交易用途',
            value: 'transactionPurpose',
            type: 'select',
            onChange: () => {
              this.handleTransactionPurposeChange();
            },
            onvisibilitychange: () => {
              this.baseForm.transactionPurposeOptions = [];
              this.getEnum();
            },
          },
          {
            label: '账户名称',
            value: 'accountName',
            type: 'select',
            onvisibilitychange: () => {
              this.baseForm.accountNameOptions = [];
              this.getAccountData();
            },
          },
          {
            label: '收入金额',
            value: 'transactionAmount',
            type: 'input',
          },
          {
            label: '对方户名',
            value: 'oppositeAccountName',
            type: 'el-autocomplete',
            placeholder: '请输入对方户名',
            valueKey: 'oppsiteAcctName',
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let searchData = [];
              let filterData = [];
              const userId = this.userInfo.staffTFInfo.userId;
              if (queryString && queryString.length) {
                searchData = JSON.parse(localStorage.getItem(`${userId}_opAcctName`));
                searchData.filter((item) => {
                  if (item.includes(queryString)) {
                    filterData.push({
                      oppsiteAcctName: item,
                    });
                  }
                });
                // this.onSearch(true);
                cb(filterData);
              } else {
                cb(filterData);
              }
            },
          },
          {
            label: '对方账号',
            value: 'oppositeAccountNumber',
            type: 'el-autocomplete',
            valueKey: 'oppsiteAcctNum',
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let searchData = [];
              let filterData = [];
              const userId = this.userInfo.staffTFInfo.userId;
              if (queryString && queryString.length) {

                searchData = JSON.parse(localStorage.getItem(`${userId}_opAcctNum`));
                searchData.length > 0 && searchData.filter((item) => {
                  if (item.includes(queryString)) {
                    filterData.push({
                      oppsiteAcctNum: item,
                    });
                  }
                });
                // this.onSearch(true);
                cb(filterData);
              } else {
                cb(filterData);
              }
            },
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
          },
        ],
        rules: {
          transactionTime: [ // 交易时间
            { required: true, message: '请选择交易时间', trigger: 'blur' },
          ],
          transactionPurpose: [ // 交易用途
            { required: true, message: '请选择交易用途', trigger: 'blur' },
          ],
          accountName: [ // 账户名称
            { required: true, message: '请选择账户名称', trigger: 'blur' },
          ],
          transactionAmount: [ // 收入金额
            { required: true, message: '请输入收入金额', trigger: 'blur' },
            { validator: this.checkMoney, trigger: 'blur' },
          ],
          oppositeAccountName: [ // 对方户名
            { required: true, message: '请输入对方户名', trigger: 'blur' },
          ],
          oppositeAccountNumber: [ // 对方账号
            { required: true, message: '请输入对方账号', trigger: 'blur' },
          ],
          remark: [ // 备注
            { required: false, message: '请输入备注', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    checkMoney (rule, value, call) {
      if (value && value < 0) {
        call('收入金额不可为负数');
      } else {
        call();
      }
    },
    async getEnum () {
      const transactionPurposeOptionsList = await getOtherIncomeSysData({ // 交易用途
        codeType: 'TRANSACTION_PURPOSE',
      });
      this.baseForm.transactionPurposeOptions = transactionPurposeOptionsList[0];
    },
    async getAccountData () {
      const res = await companyBankcardList({
        // userId: this.userInfo.staffTFInfo.userId,
        // userType: 2,
        // showMoney: 'true',
      });
      let priObj = {};
      if (res.allPriAcct.length > 0) {
        priObj = res.allPriAcct.map((item) => ({
          label: item.acctName, // 账户名称
          value: item.acctNo, // 银行卡号
          accountType: item.bankType, // 账户类型
          bankCardNo: item.acctNo,
          accountName: item.acctName,
        }));
        this.baseForm.accountNameOptions.push(...priObj);
      }
      let pubObj = {};
      if (res.allPubAcct.length > 0) {
        pubObj = res.allPubAcct.map((item) => ({
          label: item.acctName, // 账户名称
          value: item.acctNo, // 银行卡号s
          accountType: item.bankType, // 账户类型
          bankCardNo: item.acctNo,
          accountName: item.acctName,

        }));
        this.baseForm.accountNameOptions.push(...pubObj);
      }
    },
    async getList () {
      await this.getEnum();
      await this.getAccountData();
    },
    handleTransactionPurposeChange () {
      let Field = false;
      const transactionPurpose = this.$refs.baseForm.getVal('transactionPurpose');
      if (`${transactionPurpose}` === '4') {
        // 交易用途为其他，备注必填
        Field = true;
      }
      this.baseForm.rules.remark[0].required = Field;
    },

    async sub () {
      let formData = null;
      formData = await this.$refs.baseForm.sub();
      let accountArr = [];
      this.baseForm.accountNameOptions.map((item) => {
        if (item.bankCardNo === formData.accountName) {
          accountArr = item;
        }
      });
      if (formData) {
        formData = {
          transactionType: 1, // 交易类型
          transactionTime: formData.transactionTime,
          accountName: accountArr.accountName,
          bankCardNo: formData.accountName,
          accountType: accountArr.accountType,
          transactionMode: 1, // 交易方式
          transactionAmount: formData.transactionAmount,
          oppositeAccountNumber: formData.oppositeAccountNumber,
          oppositeAccountName: formData.oppositeAccountName,
          transactionPurpose: formData.transactionPurpose,
          remark: formData.remark,
        };
      }
      return formData;
    },

    async init (data = {}) {
      if (!data.transactionTime) {
        data.transactionTime = formatDateTimeSecond(new Date());
      }
      this.$refs.baseForm.setVal(data);

    },
  },
};
</script>

<style scoped lang="scss">
</style>
